function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';
import { FormDate } from '@uncinc/uncinc-react-kitchen-sink';
import { getEarliestDate, getLatestDate, parseDateStringToDate } from '../../../helpers/date';
var WebformDateTime = function WebformDateTime(_ref) {
  var entity = _ref.entity,
    values = _ref.values,
    errors = _ref.errors,
    touched = _ref.touched;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // Default props.
  var title = entity.get('#title', '');
  var required = entity.get('#required', false);
  var description = entity.get('#description', '');
  var key = entity.get('#webform_key', '');
  var requiredError = entity.get('#required_error', '');
  var disabled = entity.get('#disabled', false);

  // Specific dateTime props.
  var dateTimeMin = entity.get('#date_min', '');
  var dateTimeMax = entity.get('#date_max', '');
  var dateMin = entity.get('#date_date_min', '');
  var dateMax = entity.get('#date_date_max', '');
  var wrapperClassNames = c('WebformDateTime', entity.getIn(['#wrapper_attributes', 'class'], Immutable.List()).join(' '));
  var labelClassNames = c(entity.getIn(['#label_attributes', 'class'], Immutable.List()).join(' '));
  var elementClassNames = c(entity.getIn(['#attributes', 'class'], Immutable.List()).join(' '));

  // Drupal validation for dateTime fields works as follows:
  // -------------------------------------------------------
  // * !date_min && !date_date_min => No validation on min value
  // * date_min && !date_date_min => Validation on min value using date_min field
  // * !date_min && date_date_min => Validation on min value using date_date_min field
  // * date_min && date_date_min => Validation on min value using highest value between the two.
  // * Same applies for max value, where, if both date_max && date_date_max are filled in,
  //   Drupal chooses the lowest value between the two for validation.
  //
  // We have to apply the same for client side validation, which is what we do here.
  var _useMemo = useMemo(function () {
      var formatDate = function formatDate(date) {
        if (!date) {
          return;
        }

        // Return the date in a YYYY-MM-DD format.
        return date.toISOString().split('T')[0];
      };
      var min = getLatestDate([parseDateStringToDate(dateTimeMin), parseDateStringToDate(dateMin)]);
      var max = getEarliestDate([parseDateStringToDate(dateTimeMax), parseDateStringToDate(dateMax)]);
      return [formatDate(min), formatDate(max)];
    }, [dateTimeMin, dateTimeMax, dateMin, dateMax]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    min = _useMemo2[0],
    max = _useMemo2[1];
  var validation = function validation(value) {
    var error;
    if (required && !value) {
      error = requiredError || t(['webform.components.date_time_field.required', 'webform.required', 'webform_required']);
    }
    var currentDate = parseDateStringToDate(value);
    var minDate = parseDateStringToDate(min);
    var maxDate = parseDateStringToDate(max);

    // Invalid current date.
    if (value && !currentDate) {
      return error = t(['webform.components.date_time_field.invalid', 'webform.invalid', 'webform_invalid']);
    }

    // Current date is lower than minimum date.
    if (currentDate && minDate && getEarliestDate([currentDate, minDate]) === currentDate) {
      error = t(['webform.components.date_time_field.min', 'webform.min', 'webform_min'], {
        min: min
      });
    }

    // Current date is higher than maximum date.
    if (currentDate && maxDate && getLatestDate([currentDate, maxDate]) === currentDate) {
      error = t(['webform.components.date_time_field.max', 'webform.max', 'webform_max'], {
        max: max
      });
    }
    return error;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/React.createElement(FormDate, {
    title: title,
    required: required,
    description: description,
    fieldName: key,
    validation: validation,
    touched: touched[key],
    error: errors[key],
    value: values[key],
    className: elementClassNames,
    labelClassName: labelClassNames,
    disabled: disabled,
    min: min,
    max: max
  }));
};
export default WebformDateTime;